class SlideshowComponentMobile extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.container = null;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeSwiper());
    } else {
      this.initializeSwiper();
    }
  }

  initializeSwiper() {
    this.container = this.querySelector('.announcement-swiper');
    
    if (!this.container) {
      console.warn('SlideshowComponentMobile: Container not found');
      return;
    }

    if (typeof Swiper === 'undefined') {
      console.warn('SlideshowComponentMobile: Swiper library not loaded');
      return;
    }

    this.createSwiper();
  }

  createSwiper() {
    this.cloneSlides();
    
    const slides = this.querySelectorAll('.announcement-swiper .swiper-slide');
    if (slides.length < 2) {
      console.warn('SlideshowComponentMobile: Not enough slides for loop mode');
      return;
    }

    this.swiper = new Swiper(this.container, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      loop: true,
      allowTouchMove: false,
      allowSlideNext: false,
      allowSlidePrev: false,
      
      on: {
        init: () => {
          console.log('SlideshowComponentMobile: Swiper initialized');
        }
      }
    });
  }

  cloneSlides() {
    const wrapper = this.querySelector('.announcement-swiper .swiper-wrapper');
    if (!wrapper) return;

    const originalSlides = wrapper.querySelectorAll('.swiper-slide');
    
    originalSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      wrapper.appendChild(clone);
    });
    
    originalSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      wrapper.appendChild(clone);
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('slideshow-component-mobile', SlideshowComponentMobile);